module.exports = __webpack_public_path__ + "media/icons/checkmark-efb6eace.png";